// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Cart: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 46 50" enableBackground="new 0 0 46 50" xmlSpace="preserve" fill="currentColor">
<g>
	<path d="M44.72,12.82c-0.9-0.97-2.18-1.53-3.5-1.53H15.26v4h25.95c0.3,0,0.49,0.16,0.58,0.25c0.08,0.09,0.21,0.27,0.21,0.53
		l-2.06,13.27c-0.12,0.67-0.65,1.15-1.26,1.15h-0.65l-0.26-6l-4,0.18l0.26,5.82h-3.79V18.95h-4V30.5h-3.53V18.95h-4V30.5H16.9
		c-0.61,0-1.13-0.47-1.25-1.12L11.18,4.42C10.73,1.86,8.55,0,6,0H0v4h6c0.61,0,1.13,0.47,1.25,1.12l4.47,24.96
		c0.45,2.56,2.63,4.42,5.19,4.42h21.78c2.56,0,4.75-1.87,5.2-4.5l2.08-13.42l0.02-0.16C46.08,15.11,45.62,13.79,44.72,12.82z"/>
	<path d="M38.16,38.41c-2.21,0-4.11,1.41-4.88,3.39H22.33c-0.78-1.98-2.67-3.39-4.89-3.39c-2.91,0-5.27,2.42-5.27,5.39
		s2.36,5.39,5.27,5.39c2.21,0,4.11-1.41,4.89-3.39h10.95c0.78,1.98,2.67,3.39,4.88,3.39c2.91,0,5.27-2.42,5.27-5.39
		S41.07,38.41,38.16,38.41z M17.44,45.19c-0.7,0-1.27-0.62-1.27-1.39s0.57-1.39,1.27-1.39c0.7,0,1.27,0.62,1.27,1.39
		S18.15,45.19,17.44,45.19z M38.16,45.19c-0.7,0-1.27-0.62-1.27-1.39s0.57-1.39,1.27-1.39s1.27,0.62,1.27,1.39
		S38.86,45.19,38.16,45.19z"/>
</g>
</svg>;
};

export default React.memo(Cart);
